const buildNewTabAttribute = prop => {
  return prop.shouldOpenInTab || (prop.shouldOpenInTab === undefined && prop.href && prop.href.indexOf('//') >= 0)
    ? ` target="_blank" `
    : ``
}

export default buildNewTabAttribute
